import * as constants from './constants'

export const addToBasket = item => ({
    type: constants.ADD_TO_BASKET,
    item,
})

export const removeFromBasket = item => ({
    type: constants.REMOVE_FROM_BASKET,
    item,
})

export const clearBasket = () => ({
    type: constants.CLEAR_BASKET,
})

export const clearPurchaseCompleted = () => ({
    type: constants.CLEAR_PURCHASE_COMPLETED,
})

export const setAutoRenew = (item, autoRenew) => ({
    type: constants.SET_AUTO_RENEW,
    item,
    autoRenew,
})

export const redeemPromoCode = (item, rawPromoCode) => ({
    type: constants.REDEEM_PROMO_CODE,
    item,
    rawPromoCode,
})

export const redeemedPromoCode = (item, promoCode, result) => ({
    type: constants.REDEEMED_PROMO_CODE,
    item,
    promoCode,
    result,
})

export const removePromoCode = item => ({
    type: constants.REMOVE_PROMO_CODE,
    item,
})

export const makePurchase = (singleItem, recaptchaToken) => ({
    type: constants.MAKE_PURCHASE,
    singleItem,
    recaptchaToken,
})

export const paymentSuccess = (orderId, payId, cardToken) => ({
    type: constants.PAYMENT_SUCCESS,
    orderId,
    payId,
    cardToken,
})

export const paymentCancelled = () => ({
    type: constants.PAYMENT_CANCELLED,
})

export const paymentError = error => ({
    type: constants.PAYMENT_ERROR,
    error,
})

export const purchaseCompleted = (basket, paymentTotal) => ({
    type: constants.PURCHASE_COMPLETED,
    basket,
    paymentTotal,
})

export const extendPurchaseCompleted = () => ({
    type: constants.EXTEND_PURCHASE_COMPLETED,
})

export const purchaseError = () => ({
    type: constants.PURCHASE_ERROR,
})
